import React from 'react'
import { RadioProps } from './Input.types'
import { Fill, Radio, Wrapper } from './styled'

const InputRadio: React.FC<RadioProps> = ({ children, disabled, ...restProps }) => {
  return (
    <Wrapper disabled={disabled}>
      <label>
        {children}
        <Radio type='radio' disabled={disabled} {...restProps} />
        <Fill />
      </label>
    </Wrapper>
  )
}

export default InputRadio
